<template>
  <div class="recommended-popup-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" label-width="100px">
        <div class="item-box">
          <div class="item-left">
            <el-form-item label="番号:" prop="">
              <el-input size="small" placeholder="请输入番号" v-model="params.number"></el-input>
            </el-form-item>
            <el-form-item label="标题:" prop="">
              <el-input size="small" placeholder="请输入标题" v-model="params.number"></el-input>
            </el-form-item>
            <el-form-item label="演员:" prop="">
              <el-input size="small" placeholder="请输入或选择演员" v-model="params.number"></el-input>
            </el-form-item>
          </div>
          <div class="item-right">
            <el-form-item label="封面:" prop="cover">
              <base-upload :cover="params.cover" :action="action" :wSize="360" :hSize="640" :width="'220px'" :height="'150px'"></base-upload>
            </el-form-item>
          </div>
        </div>
        <div class="item-box">
          <div class="item-left">
            <el-form-item label="频道:" prop="platform">
              <el-select size="small" placeholder="推荐频道" style="width: 250px" v-model="params.number">
                <el-option :label="item.label" :value="item.value" v-for="item in channelSelection" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item-right">
            <el-form-item label="推荐时间:" prop="">
              <el-date-picker type="datetime" v-model="params.data" placeholder="选择日期时间" size="small">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      flag: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      // 频道选择
      channelSelection: [
        {
          label: '日本',
          value: 1
        },
        {
          label: '欧美',
          value: 2
        },
        {
          label: '动漫',
          value: 3
        },
        {
          label: '金币专区',
          value: 4
        },
        {
          label: '麻豆传媒',
          value: 5
        },
      ],
      // 条件选择
      conditionalSelection: [
        {
          label: 'VIP',
          value: 1
        },
        {
          label: '免费',
          value: 2
        },
        {
          label: '付费',
          value: 3
        },
        {
          label: '限免',
          value: 4
        },
      ],
      statusType: [
        {
          label: '已上架',
          value: 1
        },
        {
          label: '未上架',
          value: 2
        },
        {
          label: '已下架',
          value: 3
        }
      ],
      params: {
        number: '',
      }
    }
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false
    },
    open() {
      this.dialogVisible = true
      this.title = '推荐影片'
    }

  }
}
</script>
<style scoped lang="scss">
.item-box {
  display: flex;
  justify-content: space-around
}
</style>